import { useSearchParams } from "react-router-dom";
import type { Tag as TagItem } from "@textureninja/shared";

interface Props {
  tags: TagItem[];
}

export function FilterByTag({ tags }: Props) {
  const [params, setParams] = useSearchParams();
  const selected = params.getAll("tags");

  function toggleTag(tag: string) {
    const next = new URLSearchParams(params);
    const current = next.getAll("tags");
    next.delete("tags");
    if (current.includes(tag)) {
      for (const t of current) if (t !== tag) next.append("tags", t);
    } else {
      for (const t of current) next.append("tags", t);
      next.append("tags", tag);
    }
    setParams(next);
  }

  function clearTags() {
    const next = new URLSearchParams(params);
    next.delete("tags");
    setParams(next);
  }

  if (!tags.length) return null;

  return (
    <div style={{ margin: "20px 0 4px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 8,
          gap: 12,
        }}
      >
        <span
          style={{
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,0.5)",
          }}
        >
          Filter by tag {selected.length > 0 && `(${selected.length})`}
        </span>
        {selected.length > 0 && (
          <button
            type="button"
            onClick={clearTags}
            style={{
              fontSize: 12,
              color: "rgba(255,255,255,0.6)",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: "2px 6px",
              borderRadius: 4,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "rgba(255,255,255,0.6)";
            }}
          >
            Clear all
          </button>
        )}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {tags.map(({ tag }) => {
          const active = selected.includes(tag);
          return (
            <button
              key={tag}
              type="button"
              onClick={() => toggleTag(tag)}
              className={active ? "tn-tag is-active" : "tn-tag"}
              aria-pressed={active}
            >
              {tag}
            </button>
          );
        })}
      </div>
    </div>
  );
}
